import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { get } from "../utils/fetch-api";
import { CategoriesModel, ProductModel } from "../data/categories.model";

interface MenuData {
  products: ProductModel[];
  restaurantProducts: ProductModel[];
  categories: CategoriesModel[];
  isLoading: boolean;
}

const MenuDataContext = createContext<MenuData>({
  products: [],
  restaurantProducts: [],
  categories: [],
  isLoading: true,
});

interface ProductsResponse {
  products: ProductModel[];
  restaurantProducts: ProductModel[];
}

export const MenuDataProvider = ({ children }: { children: ReactNode }) => {
  const [products, setProducts] = useState<ProductModel[]>([]);
  const [restaurantProducts, setRestaurantProducts] = useState<ProductModel[]>(
    [],
  );
  const [categories, setCategories] = useState<CategoriesModel[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      get<ProductsResponse>("/api/menu/products"),
      get<CategoriesModel[]>("/api/menu/categories"),
    ])
      .then(([productsRes, categoriesRes]) => {
        setProducts(productsRes.products);
        setRestaurantProducts(productsRes.restaurantProducts);
        setCategories(categoriesRes);
      })
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <MenuDataContext.Provider
      value={{ products, restaurantProducts, categories, isLoading }}
    >
      {children}
    </MenuDataContext.Provider>
  );
};

export const useMenuData = () => useContext(MenuDataContext);
